import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import Box from 'shopper/components/Box';
import Flex from 'shopper/components/Flex';

import OfferMainFooter from './OfferMainFooter';
import OfferMainTopMobile from './OfferMainTopMobile';
import OfferShowcase from './OfferShowcase';

const StatusAlert = dynamic(() => import('./StatusAlert'), { ssr: false });

const OfferMain = ({
  commentsElem,
  gaEventCategory,
  goToStoreButtonRef,
  mostRelevantKeyword,
  offerClicks,
  offerCommentsCount,
  offerCoupon,
  offerId,
  offerInstructions,
  offerIsHighlight,
  offerLikes,
  offerOldPrice,
  offerPhoto,
  offerPrice,
  offerPriceType,
  offerQrCode,
  offerStatusName,
  offerTags,
  offerTitle,
  offerWishlistElem,
  storeDomain,
  storeImage,
  userId,
  ...rest
}) => (
  <>
    <Flex as="section" flexDirection="column" mb={4} full {...rest}>
      <StatusAlert statusName={offerStatusName} userId={userId} />
      <Box display="block" full>
        <OfferMainTopMobile
          offerClicks={offerClicks}
          offerId={offerId}
          offerInstructions={offerInstructions}
          offerPrice={offerPrice}
          offerPriceType={offerPriceType}
          offerStatusName={offerStatusName}
          offerCoupon={offerCoupon}
          storeDomain={storeDomain}
          userId={userId}
        />
        <OfferShowcase
          gaEventCategory={gaEventCategory}
          goToStoreButtonRef={goToStoreButtonRef}
          mostRelevantKeyword={mostRelevantKeyword}
          offerCoupon={offerCoupon}
          offerId={offerId}
          offerIsHighlight={offerIsHighlight}
          offerOldPrice={offerOldPrice}
          offerPhoto={offerPhoto}
          offerPrice={offerPrice}
          offerPriceType={offerPriceType}
          offerQrCode={offerQrCode}
          offerStatusName={offerStatusName}
          offerTags={offerTags}
          offerTitle={offerTitle}
          storeDomain={storeDomain}
          storeImage={storeImage}
        />
        <OfferMainFooter
          commentsElem={commentsElem}
          offerCommentsCount={offerCommentsCount}
          offerCoupon={offerCoupon}
          offerClicks={offerClicks}
          offerId={offerId}
          offerInstructions={offerInstructions}
          offerLikes={offerLikes}
          offerPrice={offerPrice}
          offerPriceType={offerPriceType}
          offerStatusName={offerStatusName}
          offerTitle={offerTitle}
          storeDomain={storeDomain}
          userId={userId}
          offerWishlistElem={offerWishlistElem}
        />
      </Box>
    </Flex>
  </>
);

OfferMain.defaultProps = {
  commentsElem: null,
  offerCoupon: null,
  offerInstructions: null,
  offerOldPrice: 0,
  offerQrCode: null,
  offerWishlistElem: null,
  storeImage: null,
};

OfferMain.propTypes = {
  commentsElem: PropTypes.shape(),
  gaEventCategory: PropTypes.string.isRequired,
  goToStoreButtonRef: PropTypes.shape().isRequired,
  mostRelevantKeyword: PropTypes.string.isRequired,
  offerClicks: PropTypes.number.isRequired,
  offerCommentsCount: PropTypes.number.isRequired,
  offerCoupon: PropTypes.string,
  offerId: PropTypes.number.isRequired,
  offerInstructions: PropTypes.string,
  offerIsHighlight: PropTypes.bool.isRequired,
  offerLikes: PropTypes.number.isRequired,
  offerOldPrice: PropTypes.number,
  offerPhoto: PropTypes.string.isRequired,
  offerPrice: PropTypes.number.isRequired,
  offerPriceType: PropTypes.string.isRequired,
  offerQrCode: PropTypes.string.isRequired,
  offerStatusName: PropTypes.string.isRequired,
  offerTags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    })
  ).isRequired,
  offerTitle: PropTypes.string.isRequired,
  offerWishlistElem: PropTypes.shape(),
  storeDomain: PropTypes.string.isRequired,
  storeImage: PropTypes.string,
  userId: PropTypes.number.isRequired,
};

export default OfferMain;
